module.exports = __webpack_public_path__ + "static/lihatybacpreview-a160f0103b3b279213c621b659a20776.jpg";